
<template>

	<div>
        <section class="page-banner page-banner-sec">
            <h1 class="section-title" style="">{{ $t('forums.posts') }}</h1>
        </section>

		
		<div class="card">
            <div class="card-header bg-transparent header-elements-inline">
				<div class="row">
					<div class="col-5">
						<h2 class="card-title"><i class="icon-make-group mr-1"></i>{{ $t('forums.title_topic') }}{{topicTitle}} </h2>
					</div>
				
					<div class="col-1">
						<button class="btn btn-primary btn-lg btn-block" @click="newPost" v-b-tooltip :title= getpostmessage><i class="fa fa-lg fa-plus" aria-hidden="true"></i></button>	
					</div>
					<div class="col-1">
						<button class="btn btn-primary btn-lg btn-block" @click="$router.go(-1)" v-b-tooltip
							title="Back to topics">{{"Back"}}</button>
					</div>
					<div class="col-5">
					</div>					
				</div>		
			</div>
		

			<div class="table-responsive">
				<table class="table text-wrap table-striped table-hover">
					<thead>
						<tr>
							
							<th><span class="ml-3">{{ $t('forums.post') }}</span></th>
                            
						</tr>
					</thead>
					<tbody data-link="row" class="rowlink">
                		<tr v-for="post in posts" :key="post.id">
							<td>
								<div class="row mt-2">
									<div class="col-2">
										<UserIdenticon :id="post.user_id" :size="50" class="ml-4"/>
										<div class="ml-2 mt-1">{{ "User ID: " + post.user_id}}</div>
										<div class="ml-2">{{ user(post.user_id)}}</div>
										<div class="ml-2">{{"Post ID: " + post.id}}</div>
									</div>
										<div class="col-10">
											<div class="pointer position-relative popreply">{{post.body}}</div>
											<div v-if="post.aasm_state=='hidden'" class="text-danger">{{"Reason for Hiding Post: " +  post.deletion_reason}}</div>
											<div class="row mt-2">
												<!-- <div class="col-4">
													<div>{{"Post ID: " + post.id}}</div>
													<div>{{"Poster ID: " + post.user_id}}</div>
												</div> -->
												<div class="col-4">
													{{"Date: " + getDate(post.created_at)}} 
												</div>
												<div class="col-3" v-if="post.aasm_state=='visible'">
													<span class="float-right " @click="reportPost(post.id)" style="cursor: pointer; color:#2196F3;"> {{"Report Post"}} </span>
													<span class="float-right mr-4" @click="reply(post)" style="cursor: pointer; color:#2196F3;"> {{"Reply"}} </span> 
												</div>
											</div>
										</div>
								</div>	
							</td>	
						</tr>

					</tbody>
				</table>
				<b-pagination v-if="pagination.total_count > pagination.per_page" size="lg" :total-rows="pagination.total_count" v-model="page" :per-page="pagination.per_page" align="center" class="m-2 mt-4 border bg-light"></b-pagination>
			</div>
		</div>

	</div>

</template>

<script>
// Vuex Stores
import { mapActions, mapGetters } from 'vuex'

// Common OTU Components
import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler, errMessage } from '@/lib/handlers'
import Topic from '@/models/topic';
import Post from '@/models/post';
import ModerationAction from '@/models/moderation_action';

export default {
	components: {
		UserIdenticon:    () => import ('@/components/UserIdenticon')
	},
	 data () {
	 	return {
	 		loaded: false,
	 		error: false,
			page: 1,
			forum_id: null,
            topic_id: null,
	 	}
	},
	watch: {
		'page': {
			 handler () {
				 this.fetchPosts({forumId: this.$route.params.forum_id, topicId: this.$route.params.topic_id, page: this.page, per_page: 20}).then((v) => this.loaded = true);
			}
		}
	},
	created () {
		this.forum_id = this.$route.params.forum_id;
        this.topic_id = this.$route.params.topic_id;
		this.fetchPosts({forumId: this.$route.params.forum_id, topicId: this.$route.params.topic_id, page: this.page, per_page: 20}).then((v) => this.loaded = true);
		
	},
	computed: {
        ...mapGetters(['currentUserId']),
		currentUser () {
			return this.$store.state.auth.user;
		},
	   posts () {
         return this.$store.state.forums.posts;
	   },
	   pagination () {
			return this.$store.state.forums.Pagination;
		},
		topicTitle(){
			return this.$route.query.title ? this.$route.query.title : '';
		}
	},
	
methods: {
		...mapActions(['fetchPosts', 'createPost','fetchCurrentUser','createModerationAction']),
		...mapNotificationEventActions,
		newPost () {
            let ref = this;
			this.$swal({
				title: 'New Post',
				text: 'Post Body',
				input: 'textarea',
				showCancelButton: true,
				confirmButtonText: 'Save',
				showLoaderOnConfirm: true,
  				preConfirm: (body) => {
					let post = new Post({body: body, userId: this.currentUser.id, topicId: ref.topic_id});
				     return this.createPost({forumId: ref.forum_id, topicId: ref.topic_id, post: post}).catch(err => {
					 	let error = errMessage(err);
					 	this.$swal.showValidationMessage( `Creation failed:<br/>${error}` );
					 })
				}
			});
		},
        user (id) {
			//return (this.$store.state.forums.users && this.$store.state.forums.users[id] && this.$store.state.forums.users[id].first_name) ? this.$store.state.forums.users[id].first_name : "User ID:" + id;
			return (this.$store.state.forums.users && this.$store.state.forums.users[id] && this.$store.state.forums.users[id].first_name) ? this.$store.state.forums.users[id].first_name : '';    
	   },
	   getDate(date){
			var myDate = new Date(date);
			return myDate.toLocaleString();
	   },
	   getpostmessage(){
		   return this.$t('forums.add_post') 
	   },
	   reportPost (post_id) {
            let ref = this;
			this.$swal({
				title: 'Report Post',
				text: 'Report reason',
				input: 'textarea',
				showCancelButton: true,
				confirmButtonText: 'Save',
				showLoaderOnConfirm: true,
  				preConfirm: (reason) => {
					let moderation_action = new ModerationAction({userComment: reason, userId: this.currentUser.id, postId: post_id});
					 return this.createModerationAction({forum_id: this.forum_id, post_id: post_id, moderation_action: moderation_action}).catch(err => {
					  let error = errMessage(err);
					  this.$swal.showValidationMessage( `Reporting a post failed:<br/>${error}` );
					})
				}
			});
		},
		reply (post) {
            let ref = this;
			let original_post = post
			this.$swal({
				title: 'Reply Post',
				//text: 'Reply Body',
				input: 'textarea',
				showCancelButton: true,
				confirmButtonText: 'Save',
				showLoaderOnConfirm: true,
  				preConfirm: (body) => {
					//let b = original_post.body + '\n' + "Poster: "+ this.user(original_post.user_id)+ " wrote on "+ this.getDate(original_post.created_at) + '\n\n' + ">>> "+body;
					let b = original_post.body + '\n' + "User ID: "+ original_post.user_id + " wrote on "+ this.getDate(original_post.created_at) + '\n\n' + ">>> "+body;
					//let b = original_post.body + '\n'+ ' Poster ID: ' + original_post.user_id +  '\n\n' + body 
					let post = new Post({body: b, userId: this.currentUser.id, topicId: ref.topic_id});
				     return this.createPost({forumId: ref.forum_id, topicId: ref.topic_id, post: post}).catch(err => {
					 	let error = errMessage(err);
					 	this.$swal.showValidationMessage( `Creation failed:<br/>${error}` );
					 })
				}
			});
		},
    }
}
</script>


